import api from "./apiMaster";

export default {
  login(params) {
    return api.post('master/admin/login', params);
  },
  
  logout() {
    return api.post('master/admin/logout');
  },
};
